import $ from 'jquery';

export default function() {
  $('.js-image-popup').on('click', function () {
    const src = $(this).data('full') || $(this).attr('src');

    const $popup = $(`
      <div class="image-popup">
        <div class="image-popup__overlay js-image-popup-close"></div>
        <div class="image-popup__content">
          <button class="image-popup__close-btn js-image-popup-close" type="button"></button>
          <img src="${src}" alt="">
        </div>
      </div>
    `);

    $('body').append($popup);

    $popup.find('.js-image-popup-close').on('click', function () {
      $popup.remove();
    });
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/project/image-popup.js